import React, { useState } from "react";
import "./DepositModal.css";

const DepositModal = ({ deposit, onClose, onAction }) => {
  // console.log('deposit: ', deposit);
  const [loading, setLoading] = useState(false);

  if (!deposit) return null;

  const handleActionClick = async (action) => {
    const adminComment = prompt("Enter admin remark:");
    if (!adminComment) return;

    setLoading(true);
    try {
      await onAction(deposit.id, action, adminComment);
      onClose();
    } catch (err) {
      alert("Action failed: " + err.message);
    }
    setLoading(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <button className="modal-close-x" onClick={onClose}>
          ×
        </button>
        
        <div className="modal-body">
          <div className="modal-left-section">
            <h2>Deposit Details</h2>
            <div className="details">
              <p><strong>Client Email :</strong> {deposit.email || "-"}</p>
              <p><strong>Deposit Amount :</strong> ${deposit.amount || 0}</p>
              <p><strong>Trading Account :</strong> {deposit.trade_id || "-"}</p>
              <p><strong>Deposit Method :</strong> {deposit.type ? deposit.type.toUpperCase() : "-"}</p>
              <p><strong>Transaction ID :</strong> {deposit.transaction_id || "-"}</p>
              <p><strong>Deposit Reference ID :</strong> {deposit.reference_id || "-"}</p>
            </div>

            <h2>Deposit Status</h2>
            <div className="details">
              <p><strong>Deposit Date :</strong> {new Date(deposit.created_at).toLocaleString()}</p>
              <p>
                <strong>Status :</strong>{" "}
                <span className={`status ${deposit.status || "pending"}`}>
                  {deposit.status || "pending"}
                </span>
              </p>
              <p><strong>Admin Remark :</strong> {deposit.admin_comment || "-"}</p>
            </div>
          </div>

          <div className="modal-right-section">
            <h2>Payment Proof</h2>
            <div className="details">
              <p>
                <strong>Payment Proof :</strong>{" "}
                {deposit.transaction_proof ? (
                  <div className="proof-image-container">
                    <img 
                      src={`https://server.majestyfx.com${deposit.transaction_proof}`} 
                      alt="Transaction Proof" 
                      className="proof-image"
                      onClick={() => window.open(`https://server.majestyfx.com${deposit.transaction_proof}`, '_blank')}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'inline';
                      }}
                    />
                    <a 
                      href={`https://server.majestyfx.com${deposit.transaction_proof}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{display: 'none'}}
                    >
                      View Payment Proof
                    </a>
                  </div>
                ) : "-"}
              </p>
            </div>
          </div>
        </div>

        <div className="modal-actions">
          {deposit.status === "pending" && (
            <>
              <button className="action-btn approve" onClick={() => handleActionClick("approve")} disabled={loading}>
                Approve
              </button>
              <button className="action-btn reject" onClick={() => handleActionClick("reject")} disabled={loading}>
                Reject
              </button>
            </>
          )}
          <button className="close-btn" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default DepositModal;
